import React, {Component} from "react"
import PropTypes from "prop-types"

import {TextArea} from "@irati/ui/src/FormItem"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import {EMOJI} from "@irati/ui/src/Reactions/constants"
import {recognitionSchema} from "@irati-web/fields/poll/votes/validation"
import {MAX_CHAR_LENGTH} from "@irati-web/fields/poll/votes/validation/recognition"

const PROPERTY = "desc"

class Desc extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    validation: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string
  }

  static defaultProps = {
    validation: null,
    label: "recognition.fields.poll.desc.label",
    placeholder: "recognition.fields.poll.desc.placeholder",
    id: "poll"
  }

  static getDerivedStateFromProps(props, prevState) {
    const {intl} = props
    return {
      validation: props.validation || prevState.validation || recognitionSchema(intl)
    }
  }

  state = {}

  handleChange = (value) => {
    const {poll, onChange} = this.props

    onChange(poll, PROPERTY, value)
  }

  render() {
    const {poll, intl, ...props} = this.props
    const {validation} = this.state

    return (
      <TextArea
        rows={4}
        {...props}
        maxLength={MAX_CHAR_LENGTH}
        validation={validation}
        onChange={this.handleChange}
        name={id(PROPERTY, this.props)}
        id={id(PROPERTY, this.props)}
        textReplaceTypes={[EMOJI]}
        value={poll[PROPERTY]}
      />
    )
  }
}

export default injectIntl(Desc)
